import { useQuery } from '@hooks/reactQuery';

import { getPortalMilestonesStatuses } from '@api/portalMilestones';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_MILESTONES_STATUSES } from '@constants/queryKeys';

interface IUseQueryPortalMilestonesStatusesReturned {
	portalMilestonesStatuses: Array<TSelectOption>;
	isLoadingPortalMilestonesStatuses: boolean;
}

export const useQueryPortalMilestonesStatuses = (): IUseQueryPortalMilestonesStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_MILESTONES_STATUSES],
		queryFn: getPortalMilestonesStatuses,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalMilestonesStatuses: data || [],
		isLoadingPortalMilestonesStatuses: isLoading || isFetching,
	};
};
